// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__1C4nr","author":"Table_author__1l4kB","authorImage":"Table_authorImage__1rLpz","unreadRow":"Table_unreadRow__12yyS"};